var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelTumblrSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 12,
  viewBox: "0 0 8 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 2.907c1.376-.094 2.619-.422 2.528-2.87L3.845 0l-.07 2.87H7.05v2.273l-3.276-.037.036 3.39c.374 2.239 2.462 1.463 3.24.672v1.9c-.605.503-1.8.881-2.777.932-1.68-.189-3.12-.76-3.205-3.503V5.143H0z"
})));
export default SvgChannelTumblrSm;